// extracted by mini-css-extract-plugin
module.exports = {"base":"Form_base__8edl5","enquiries":"Form_enquiries__GomP8 Form_base__8edl5","subscriptions":"Form_subscriptions__BQGeZ Form_base__8edl5","fadeOut":"Form_fadeOut__EATXW"};